module.exports = __webpack_public_path__ + "static/media/responses_empty.81acb945.svg";